// Cross carousel images
import crossBackDesktop from "../../../assets/img/models/cross/carousel/cross-back-desktop.webp";
import crossBackMobile from "../../../assets/img/models/cross/carousel/cross-back-mobile.webp";
import crossFrontDesktop from "../../../assets/img/models/cross/carousel/cross-front-desktop.webp";
import crossFrontMobile from "../../../assets/img/models/cross/carousel/cross-front-mobile.webp";
import crossSideDesktop from "../../../assets/img/models/cross/carousel/cross-side-desktop.webp";
import crossSideMobile from "../../../assets/img/models/cross/carousel/cross-side-mobile.webp";
// Cross exterior images
import crossExteriorFront from "../../../assets/img/models/cross/exterior/cross-exterior-1.webp";
import crossExteriorRear from "../../../assets/img/models/cross/exterior/cross-exterior-2.webp";
import crossExteriorWheel from "../../../assets/img/models/cross/exterior/cross-exterior-3.webp";
import crossExteriorMirror from "../../../assets/img/models/cross/exterior/cross-exterior-4.webp";
import crossExteriorGrille from "../../../assets/img/models/cross/exterior/cross-exterior-5.webp";
// Cross color images
import crossFiery from "../../../assets/img/models/cross/colors/cross-fiery.webp";
import crossAzure from "../../../assets/img/models/cross/colors/cross-azure.webp";
import crossBlack from "../../../assets/img/models/cross/colors/cross-black.webp";
import crossGray from "../../../assets/img/models/cross/colors/cross-gray.webp";
import crossSilver from "../../../assets/img/models/cross/colors/cross-silver.webp";
import crossWhite from "../../../assets/img/models/cross/colors/cross-white.webp";
import crossBlue from "../../../assets/img/models/cross/colors/cross-blue.webp";
// Cross interior images
import crossInteriorSeats from "../../../assets/img/models/cross/interior/cross-interior-5.webp";
import crossInteriorPanel from "../../../assets/img/models/cross/interior/cross-interior-1.webp";
import crossInteriorBox from "../../../assets/img/models/cross/interior/cross-interior-2.webp";
import crossInteriorAirConditioner from "../../../assets/img/models/cross/interior/cross-interior-3.webp";
import crossInteriorKeys from "../../../assets/img/models/cross/interior/cross-interior-4.webp";
// Cross Atributes
import crossAtributesDesktop from "../../../assets/img/models/cross/atributes/cross-atributes-desktop.webp";
import crossAtributesMobile from "../../../assets/img/models/cross/atributes/cross-atributes-mobile.webp";
// Hero Image
import heroImageCrossDesktop from "../../../assets/img/cross-hero-desktop.png";
import heroImageCrossMobile from "../../../assets/img/cross-hero-mobile.png";
// Cross Etiqueta
import crossEtiqueta from "../../../assets/etiquetas/Etiqueta K3 Cross EX_GT.pdf";
// Cross Fichas
import crossFichas from "../../../assets/fichas/Ficha técnica K3 Cross EX_GT.pdf";

export const crossImages = {
  carousel: {
    front: {
      desktop: crossFrontDesktop,
      mobile: crossFrontMobile,
    },
    back: {
      desktop: crossBackDesktop,
      mobile: crossBackMobile,
    },
    side: {
      desktop: crossSideDesktop,
      mobile: crossSideMobile,
    },
  },
  exterior: {
    front: {
      desktop: crossExteriorFront,
      mobile: crossExteriorFront,
    },
    rear: {
      desktop: crossExteriorRear,
      mobile: crossExteriorRear,
    },
    wheel: {
      desktop: crossExteriorWheel,
      mobile: crossExteriorWheel,
    },
    mirror: {
      desktop: crossExteriorMirror,
      mobile: crossExteriorMirror,
    },
    grille: {
      desktop: crossExteriorGrille,
      mobile: crossExteriorGrille,
    },
  },
  interior: {
    seats: {
      desktop: crossInteriorSeats,
      mobile: crossInteriorSeats,
    },
    panel: {
      desktop: crossInteriorPanel,
      mobile: crossInteriorPanel,
    },
    keys: {
      desktop: crossInteriorKeys,
      mobile: crossInteriorKeys,
    },
    airConditioner: {
      desktop: crossInteriorAirConditioner,
      mobile: crossInteriorAirConditioner,
    },
    box: {
      desktop: crossInteriorBox,
      mobile: crossInteriorBox,
    },
  },
  colors: {
    azure: crossAzure,
    fiery: crossFiery,
    blue: crossBlue,
    black: crossBlack,
    gray: crossGray,
    silver: crossSilver,
    white: crossWhite,
  },
  attributes: {
    desktop: crossAtributesDesktop,
    mobile: crossAtributesMobile,
  },
  heroVideo: {
    desktop: heroImageCrossDesktop,
    mobile: heroImageCrossMobile,
  },
  etiqueta: crossEtiqueta,
  fichas: crossFichas,
};
